import SubscriptionPool from "../../redux/services/SubscriptionPool";
import Subscription from "../../types/Subscription";
import Transaction from "../Transaction";

/** Options passed from TransactionsTab; union of transaction and rating-change options. */
type SubscribeOptionsUnion =
	| Transaction.SubscribeOptions
	| { executorId: number; dateRange?: { from: Date; to: Date } };

/**
 * Service for executor rating change records (separate table, no longer payment transactions).
 * Returns transaction-like models so the same TransactionsTab/Content can render them.
 */
class ExecutorRatingChange {
	public static fromResponse(data: any): Transaction.Model {
		return Transaction.fromResponse(data);
	}

	public static async subscribe(
		options: SubscribeOptionsUnion,
		onUpdate: Subscription.OnUpdate<Transaction.Model>,
	): Promise<Subscription<SubscribeOptionsUnion> | null> {
		const opts = options as ExecutorRatingChange.SubscribeOptions;
		const executorId = opts?.executorId;
		if (executorId == null) {
			return null;
		}
		const subscription = await SubscriptionPool.add(
			(prpc) =>
				prpc.theirsModel.executorRatingChange.subscribe({
					executorId,
					onEvent: (items: any[]) => {
						const models = (items ?? []).map((item: any) =>
							ExecutorRatingChange.fromResponse(item),
						);
						onUpdate({ models, metadataState: {} });
					},
				}),
			{ name: "ExecutorRatingChange.subscribe" },
		);

		return {
			unsubscribe: () => subscription.unsubscribe(),
			update: async (opt: SubscribeOptionsUnion) => {
				await subscription.update(opt);
			},
		} as Subscription<SubscribeOptionsUnion>;
	}
}

declare namespace ExecutorRatingChange {
	interface SubscribeOptions {
		executorId: number;
		dateRange?: { from: Date; to: Date };
	}
}

export default ExecutorRatingChange;
